import styled from '@emotion/styled';

export const ScrollProgressBarContainer = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 0.4rem;
  background-color: #395dff;
  z-index: 9999;
`;

export const ProgressLeftBar = styled.div`
  right: 0;
  position: absolute;
  height: 100%;
  background-color: #ffffff;
`;
